export const strings = {
  company: {
    name: "CodeOrigin",
    tagline: "Your technology partner for scalable growth."
  },
  
  hero: {
    headline: "We Power Your Tech Services. You Scale Revenue.",
    subtext: "Your technology partner to deliver software services under your brand — without hiring or scaling engineering teams.",
    primaryCta: "Partner With Us",
    secondaryCta: "View Services"
  },
  
  whatAreWe: {
    title: "Your Technology Execution Partner",
    content: "We work with agencies, consultants, and businesses to deliver end-to-end software development services under your brand.",
    subtitle: "You focus on acquiring clients and growing revenue — we handle the technology, delivery, and execution.",
    keyPoints: [
      "White-label technology partner",
      "No in-house team required", 
      "Scalable delivery model",
      "Long-term partnership approach"
    ]
  },
  
  outcomes: {
    title: "What You Gain",
    metrics: [
      {
        number: "85%",
        text: "Increase revenue without expanding your team"
      },
      {
        number: "3x",
        text: "Faster project delivery with experienced engineers"
      },
      {
        number: "Zero",
        text: "Hiring and operational overhead"
      },
      {
        number: "Instant",
        text: "Expand your service offerings"
      },
      {
        number: "100%",
        text: "Improve client retention with reliable delivery"
      }
    ]
  },
  
  services: {
    title: "What We Deliver",
    items: [
      {
        title: "Custom Software Development",
        description: "Web, mobile, and enterprise applications tailored to client needs."
      },
      {
        title: "Cloud Services", 
        description: "AWS, Azure, GCP solutions with scalable infrastructure."
      },
      {
        title: "Web Development",
        description: "Scalable frontend + backend systems."
      },
      {
        title: "AI & Automation Solutions",
        description: "Chatbots, workflows, data-driven systems."
      },
      {
        title: "Maintenance & Support",
        description: "Ongoing support, bug fixes, and upgrades."
      },
      {
        title: "Dedicated Development Teams",
        description: "Extend your team with our engineers."
      }
    ]
  },
  
  howItWorks: {
    title: "Simple Partnership Model",
    steps: [
      "You bring the client",
      "We build and deliver",
      "You earn the revenue"
    ],
    tagline: "We stay invisible. You stay in control."
  },
  
  portfolio: {
    title: "What We've Delivered",
    stats: [
      "100M+ user scale applications",
      "Experience across all domains", 
      "Secure and scalable architecture implementations"
    ]
  },
  
  testimonials: {
    title: "What Our Partners Say",
    subtitle: "Trusted by businesses worldwide to deliver exceptional results",
    reviews: [
      {
        name: "Sarah Johnson",
        company: "Digital Solutions Inc.",
        role: "CEO",
        avatar: "SJ",
        rating: 5,
        text: "CodeOrigin transformed our business model. We went from struggling to scale our tech services to closing 5x more deals. Their invisible partnership model is exactly what we needed."
      },
      {
        name: "Michael Chen",
        company: "CloudFirst Consulting",
        role: "Founder",
        avatar: "MC",
        rating: 5,
        text: "The quality of work is outstanding. Our clients have no idea we're working with a partner - the deliverables are always on-brand and exceed expectations. Revenue up 120% this quarter!"
      },
      {
        name: "Priya Sharma",
        company: "Tech Ventures Group",
        role: "Managing Director",
        avatar: "PS",
        rating: 5,
        text: "Finally found a reliable technology partner. Fast execution, zero hiring headaches, and our profit margins have never been better. CodeOrigin is an integral part of our growth strategy."
      },
      {
        name: "James Rodriguez",
        company: "Innovation Partners",
        role: "Co-founder",
        avatar: "JR",
        rating: 5,
        text: "We expanded our service offerings overnight without adding a single developer to our team. The partnership model is brilliant - we focus on sales, they handle delivery perfectly."
      },
      {
        name: "Emma Williams",
        company: "Startup Studio",
        role: "Director",
        avatar: "EW",
        rating: 5,
        text: "Incredible team that truly understands white-label partnerships. Professional, responsive, and technically excellent. Our client retention is at an all-time high thanks to CodeOrigin."
      },
      {
        name: "David Kumar",
        company: "Growth Agency Co.",
        role: "CEO",
        avatar: "DK",
        rating: 5,
        text: "Best decision we made was partnering with CodeOrigin. They scale with us seamlessly, quality is consistent, and our clients are thrilled. Revenue growth has been phenomenal."
      }
    ]
  },
  
  whyChooseUs: {
    title: "Why Businesses Partner With Us",
    reasons: [
      "Proven experience in scaling applications",
      "Strong focus on security and performance",
      "Flexible engagement models", 
      "Fast onboarding and execution",
      "Built for long-term partnerships"
    ]
  },
  
  contact: {
    title: "Let's Grow Your Service Revenue",
    subtitle: "Looking to expand your offerings without building a tech team? Let's partner.",
    ctaButton: "Start Partnership",
    email: "support@codeorigin.in",
    formFields: {
      name: "Name",
      company: "Company", 
      email: "Email",
      message: "Message"
    }
  },
  
  footer: {
    tagline: "Your silent technology partner for scalable growth.",
    links: ["Services", "Portfolio", "Contact"],
    positioning: "We power your tech services so you can scale revenue and margins."
  }
};
